import DeviceSignals from "../types/DeviceSignals";

// Distinguishes the device icon; the platform stores whatever the client reports, lowercased.
export const ANDROID_PLATFORM = "android";

// Lets a never-reported rep run the same cell logic, so Motion still reads N/A without the add-on.
export const NEVER_REPORTED_SIGNALS: DeviceSignals = {
  backgroundRefreshEnabled: null,
  locationPermission: null,
  motionEnabled: null,
  notificationsEnabled: null,
  platform: null,
  preciseLocationEnabled: null,
};
